import * as z from "zod/v4";

export const createCheckoutSession = {
  name: "createCheckoutSession" as const,
  input: z.object({ locationExternalId: z.string().nullish() }),
  output: z.object({ checkoutSessionId: z.string() }),
};
